import { Button, Icon } from '@smartgift/frontend-toolkit';
import React from 'react';
import { useTranslation } from 'react-i18next';

import * as S from './style';

export function EmptyTableContent({ hasDescription, createNew, feature, icon, description }) {
  const { t } = useTranslation();

  return (
    <S.EmptyTableContent>
      {icon && <Icon name={icon} size="xxl" color="var(--color-accent-primary-strong)" />}

      <S.EmptyTableContentBody>
        <S.EmptyTableTitle variant="body2Semibold">
          {createNew
            ? t('emptyTableTitle1', { feature: t(feature).toLocaleLowerCase() })
            : t('emptyTableTitle2')}
        </S.EmptyTableTitle>
        {hasDescription && (
          <S.EmptyTableDescription variant="body2" emphasis="weaker">
            {description || t('emptyTableDescription')}
          </S.EmptyTableDescription>
        )}
        {createNew && (
          <Button startIcon={<Icon name="add" />} onClick={createNew} size="sm">
            {t('addType', { type: t(feature) })}
          </Button>
        )}
      </S.EmptyTableContentBody>
    </S.EmptyTableContent>
  );
}
